<template>
  <div class="PDF-upload">
    <div class="PDF-upload-left" v-show="uploadState === 'ready'">
      <div class="title">创建版式电子书刊</div>
      <div class="btns">
        <div class="single-PDF-upload-content PDF-upload-content">
          <singlePDFUpload ref="singlePDFUpload" @updateState="updateStateHandler" @updateProgress="updateProgressHandler" @toSpace="toSpace"></singlePDFUpload>
          <div class="button-upload-cover" @click="toUpload('single')">上传单个完整PDF创建</div>
        </div>
        <div class="merge-PDF-upload-content PDF-upload-content">
          <div class="button-upload-cover vip" @click="toUpload('merge')">上传合并多个PDF创建</div>
        </div>
        <div class="batch-PDF-upload-content PDF-upload-content">
          <div class="button-upload-cover vip" @click="toUpload('batch')">批量上传完整PDF创建</div>
        </div>
      </div>
    </div>
    <div class="PDF-upload-right" v-show="uploadState === 'ready'">
      <div class="title">创建版式+流式电子书刊</div>
      <div class="btns">
        <div class="batch-PDF-upload-content PDF-upload-content">
          <div class="button-upload-cover vip" @click="toUpload('singleWord')">上传DOCX创建</div>
        </div>
      </div>
    </div>
    <UploadProgress v-show="uploadState === 'singleUploading'" :percentage="percentage" title="方正云阅读制作" message="转制作电子书刊"></UploadProgress>
    <singleWordUploading
      v-show="uploadState === 'singleWordUploading' || uploadState === 'singleWordUploadDone'"
      :uploadState="uploadState"
      :percentage="percentage"
      @updateFileName="updateFileName"
    ></singleWordUploading>
    <batchPDFUploading
      v-show="uploadState === 'batchUploading' || uploadState === 'done'"
      :type="uploadingType"
      :replaceId="replaceId"
      :uploadState="uploadState"
      @updateState="updateStateHandler"
    ></batchPDFUploading>
    <batchPDFUpload
      ref="batchPDFUpload"
      class="batch-upload-PDF"
      :type="uploadingType"
      :totalCount="totalCount"
      @updateState="updateStateHandler"
      @toVip="batchToVip"
      @toSpace="toSpace"
    ></batchPDFUpload>
    <wordUpload ref="wordUpload" class="batch-upload-PDF" :type="uploadingType" :totalCount="totalCount" @updateState="updateStateHandler" @toVip="batchToVip" @toSpace="toSpace"></wordUpload>
    <tip-dialog ref="spaceDialog" :dialogOptions="spaceDialogOptions" @clickCancel="buySpaceCancel"></tip-dialog>
    <tip-dialog ref="defaultSettingDialog" :dialogOptions="defaultSettingOptions" @clickConfirm="resetDefaultSetting"></tip-dialog>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
  </div>
</template>

<script>
import bookApis from '@api/getBook'
import { checkSettingExpire, resetDefaultSetting } from '@api/setBook'
import rotational from '@api/accuracy'
import { setEncryption } from '@/utils'
import { mapState } from 'vuex'
import TipDialog from '@components/common/TipDialog.vue'
import UploadProgress from '@components/uploadContent/uploadProgress'
import compareVipRight from '@components/common/compareVipRight.js'
import singlePDFUpload from '../components/uploadContent/singlePDFUpload'
import batchPDFUpload from '../components/uploadContent/batchPDFUpload'
import batchPDFUploading from '../components/uploadContent/batchPDFUploading'
import wordUpload from '../components/uploadContent/wordUpload.vue'
import singleWordUploading from '../components/uploadContent/singleWordUploading.vue'

export default {
  name: 'PDFUpload',
  mixins: [compareVipRight],
  data() {
    return {
      currentRef: 'single',
      uploadingType: 'single',
      uploadState: 'ready',
      percentage: 0,
      timer: null,
      totalCount: 0,
      spaceDialogOptions: {
        // 弹框类型
        type: 'space',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '您可用空间不足，请进行空间扩容'
      },
      defaultSettingOptions: {
        // 弹框类型
        type: 'tip',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '您当前的会员权益不足，部分功能不支持自定义，继续发布将重置书刊默认效果设置，是否发布？'
      },
      currentUploader: null,
      replaceId: this.$route.params.replaceId,
      fileName: ''
    }
  },
  computed: {
    ...mapState('config', {
      open: (state) => state.bookObj.open,
      dpi: (state) => state.bookObj.dpi,
      referer: (state) => state.bookObj.referer,
      displayPageNo: (state) => state.bookObj.displayPageNo
    }),
    ...mapState('common', ['vipRight']),
    userName() {
      return localStorage.getItem('username')
    },
    isSubAccount() {
      return this.$store.state.common.isSubAccount
    },
    memberDialogOptions() {
      return {
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，仅允许创建${this.$store.state.common.vipRight.bookNum}本书，创建更多需先升级会员服务。`
      }
    }
  },
  watch: {
    // 上传过程中不可切换到另一上传模块
    uploadState(newVal) {
      this.$emit('updateUploadingStatus', newVal)
    }
  },
  async mounted() {
    await this.getVipInfo()
    let id = this.$route.params.id
    let params = {
      id: id
    }
    if (id) {
      this.uploadState = 'singleUploading'
      this.timer = setInterval(() => {
        this.percentage += 10
        if (this.percentage == 90) {
          clearInterval(this.timer)
        }
      }, 100)

      //自动转换精度
      rotational.rotational(params).then((res) => {
        if (res.data.code == 0) {
          clearInterval(this.timer)
          this.percentage = 100
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          const encryption_id = setEncryption(id)
          this.$router.push({ path: '/book', query: { id: encryption_id } })
          this.$store.commit('config/UPDATE_BOOK_ID', id)
          this.$store.commit('book/UPDATE_ISSHOWWINDOW', 2)
          this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'editContent')
          this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', true)
        } else {
          clearInterval(this.timer)
          this.percentage = 0
          res.data.message &&
            this.$message({
              message: res.data.msg || '替换失败',
              type: 'warning'
            })
          this.uploadState = 'ready'
        }
      })
    }
    if (this.replaceId) {
      this.uploadingType = 'merge'
      this.uploadState = 'done'
    }
    this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'catalog')
  },
  methods: {
    // 判断上传数量是否超过权益
    async toUpload(type) {
      if (this.uploadState !== 'ready') {
        this.$refs.memberDialog.visible = true
        this.memberDialogOptions.tip = `有文件正在处理中，请稍后再试`
        return
      }
      this.$store.dispatch('common/login')
      this.uploadingType = type
      await this.getVipInfo()
      await this.$store.dispatch('manage/getSpace')
      let checkSetting = true
      await checkSettingExpire().then((res) => {
        if (res.status === 200) {
          if (res.data.data) {
            this.$refs.defaultSettingDialog.visible = true
            checkSetting = false
          }
        }
      })
      if (!checkSetting) {
        return
      }
      bookApis
        .getProductsCount({
          userName: this.userName,
          isChild: this.isSubAccount,
          type: 'book'
        })
        .then((res) => {
          if (res && res.status == 200 && res.data.code === 0) {
            this.totalCount = res.data.data.sum
            if (this.compare({ type: 'num', key: 'bookNum', value: this.totalCount })) {
              if (type !== 'single') {
                if (type === 'singleWord') {
                  this.$refs.wordUpload.upload()
                  return
                }
                if (this.compare({ type: 'boole', key: `${type}Upload` })) {
                  this.$refs.batchPDFUpload.upload()
                } else {
                  this.$refs.memberDialog.visible = true
                  this.memberDialogOptions.tip = `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
                }
              } else {
                this.$refs.singlePDFUpload.upload()
              }
            } else {
              this.$refs.memberDialog.visible = true
            }
          }
        })
    },
    resetDefaultSetting() {
      resetDefaultSetting()
      const currentRef = `${this.currentRef}PDFUpload`
      this.$refs[currentRef].upload()
    },
    updateStateHandler(state) {
      this.uploadState = state
    },
    updateFileName(fileName) {
      this.fileName = fileName
    },
    updateProgressHandler(percentage) {
      this.percentage = percentage >= 100 ? 99 : percentage
    },
    batchToVip() {
      this.$refs.memberDialog.visible = true
    },
    toSpace(currentRef) {
      this.currentRef = currentRef
      this.$refs.spaceDialog.visible = true
    },
    buySpaceCancel() {
      const currentRef = `${this.currentRef}PDFUpload`
      this.$refs[currentRef].cancelRestore()
    }
  },
  components: {
    TipDialog,
    UploadProgress,
    singlePDFUpload,
    batchPDFUpload,
    batchPDFUploading,
    wordUpload,
    singleWordUploading
  }
}
</script>

<style lang="scss" scoped>
.PDF-upload {
  width: 100%;
  // height: 100%;
  height: 240px;
  position: relative;
  display: flex;
  text-align: center;
  padding-top: 10px;
  .title {
    font-size: 16px;
    color: #3a3a3a;
    line-height: 40px;
  }
  .btns {
    width: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
  }
  &-left {
    border-right: solid #eaeaea 1px;
    .PDF-upload-content {
      margin-top: 10px;
    }
  }
  &-left,
  &-right {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .PDF-upload-content {
    width: 100%;
    .button-upload-cover {
      background-size: 100% 100%;
      border: none;
      cursor: pointer;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      // font-weight: 600;
      background-image: url(../assets/imgs/upload_PDF.png);
      color: #fff;
      &.vip {
        background-image: url(../assets/imgs/upload_PDF_vip.png);
        color: #df5813;
      }
    }
    // &.single-PDF-upload-content {
    //   transform: translateX(-50%);
    //   // top: 50%;
    //   // transform: translate(-50%, -50%);
    // }
    // &.batch-PDF-upload-content {
    //   width: 170px;
    //   top: 135px;
    //   left: 115px;
    // }
    // &.merge-PDF-upload-content {
    //   width: 170px;
    //   top: 135px;
    //   left: 315px;
    // }
  }
  &-right .btns {
    width: 200px;
    .button-upload-cover {
      line-height: 40px;
      margin-top: 56px;
    }
  }
  .tip-wrapper {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 13px;
    .tip-text {
      font-size: 14px;
      display: inline-block;
      width: 370px;
      color: #999;
    }
  }
}
</style>
